import { Component, Input } from '@angular/core';

/**
 * Panel with a collapsible body, styled as the usual `.box` so it lines up with the rest of
 * the detail screens. The header only holds the title and the chevron; anything the panel
 * needs to offer (buttons and so on) belongs in the projected body, so it is only reachable
 * while the content it acts upon is visible.
 */
@Component({
  selector: 'app-collapsible-panel',
  templateUrl: './collapsible-panel.component.html',
  styleUrls: ['./collapsible-panel.component.css']
})
export class CollapsiblePanelComponent {
  @Input() title: string;
  @Input() collapsed = true;

  get chevronIcon() {
    return (this.collapsed) ? 'icon-chevron-down' : 'icon-chevron-up';
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/collapsible-panel/collapsible-panel.component.ts